export const AMPLIFY_70 = `AMPLIFY_70`;
export const AMPLIFY_50 = `AMPLIFY_50`;
export const AMPLIFY_25 = `AMPLIFY_25`;
export const DELIVERY_CHARGES = 35;
export const COUPONS = [`AMPLIFY_70`, `AMPLIFY_50`, `AMPLIFY_25`];
